<template>
  <div class="pos-relative search-select">
    <input
      @input="onInputDataMerchant"
      @focus="openModalMerchant"
      @blur="closeModalMerchant"
      class="input-field"
      id="id-merchant"
      type="text"
      name="idMerchant"
      :class="{'inputNoValid': error}"
      autocomplete="off"
      :placeholder="placeholder"
      v-model="value">
    <div v-if="checkLengthMerchant"
         @scroll="infiniteScroll"
         ref="scrollBlock"
         class="dropdown-merchante">
      <div @click="selectMerchant(item)"
           v-for="(item, index) in items"
           :key="index">
        <p class="font-h5">{{item.name ? item.name + ', ':''}}{{item.phone_number}}</p>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'search-select',
        props: {
            allOptional: false,
            error: false,
            startValue: false,
            reset: false,
        },
        data() {
            return {
                optionAllUsers: [
                    {
                        phone_number: 'All',
                        id: 'null'
                    }
                ],
                pageNumber: 1,
                olreadyLastPage: false,

                value: '',
                placeholder: '972',
                items: [],
                visibleItems: false,
            }
        },
        methods: {
            infiniteScroll(event) {
                if (!this.olreadyLastPage) {
                    let scrollBlock = event.target
                    let scrollBlockHeight = scrollBlock.clientHeight
                    let scrollTop = scrollBlock.scrollTop
                    let scrollHeight = scrollBlock.scrollHeight
                    let endScroll = scrollTop == scrollHeight - scrollBlockHeight
                    if (endScroll) {
                        this.pageNumber++
                        this.getUsersByInput()
                    }
                }
            },
            resetInfinite() {
                console.log(this.$refs.scrollBlock)
                if (this.$refs.scrollBlock) {
                    this.$refs.scrollBlock.scrollTop = 0
                }
                this.pageNumber = 1
                this.olreadyLastPage = false
            },
            closeModalMerchant() {
                if (this.placeholder) {
                    this.value = this.placeholder
                } else {
                    this.value = ''
                }
                setTimeout(() => {
                    this.visibleItems = false
                }, 300)
            },
            openModalMerchant() {
                this.value = ''
                if (this.items.length) {
                    this.visibleItems = true
                }
            },
            selectMerchant(item) {
                this.value = (item.name ? item.name + ', ' : '') + item.phone_number
                this.placeholder = this.value
                this.visibleItems = false
                this.items = [];
                this.$emit('selectItem', item)
                console.log(item)
            },
            onInputDataMerchant() {
                if (this.value.length >= 10) {
                    this.resetInfinite()
                    this.visibleItems = true
                    this.getUsersByInput()
                }
            },
            getUsersByInput() {
                let searchString = this.setSearchString()
                this.$api.API_FIND_USER(searchString)
                    .then(response => {
                        this.successApiGetUsers(response)
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },
            successApiGetUsers(response) {
                let currentPage = response.data.data.current_page
                let lastPage = response.data.data.last_page
                if (currentPage >= lastPage) {
                    this.olreadyLastPage = true
                }
                if (this.pageNumber == 1) {
                    if (this.allOptional) {
                        this.items = this.optionAllUsers.concat(response.data.data.data)
                        console.log(this.items, 'all')
                    } else {
                        this.items = response.data.data.data
                    }
                } else {
                    this.items = this.items.concat(response.data.data.data)
                }
            },
            setSearchString() {
                let search = '?page=' + this.pageNumber
                if (this.value) {
                    search += '&search=' + this.value
                }
                return search
            },
            setStartValue() {
                if (this.startValue) {
                    this.$axios.get('moderate-users/' + this.startValue)
                        .then(response => {
                            let user = response.data.data.user
                            this.value = (user.name ? user.name + ', ' : '') + user.phone_number
                            this.placeholder = this.value
                        })
                        .catch(e => {
                            console.log(e)
                        })
                } else {
                    // this.getUsersByInput();
                }
            },
            setAllStartValue() {
                if (this.allOptional) {
                    this.value = 'All'
                    this.placeholder = this.value
                }
            }
        },
        computed: {
            checkLengthMerchant() {
                console.log()
                return !!this.items.length && this.visibleItems
            },
        },
        watch: {
            startValue() {
                this.setStartValue()
            },
            reset() {
                this.value = ''
                this.placeholder = ''
                this.items = []
            }
        },
        created() {
            this.setAllStartValue()
            this.setStartValue()
        }
    }
</script>

<style scoped>
  .dropdown-merchante {
    overflow-y: auto;
    max-height: 200px;
    padding: 0px 0px;
    position: absolute;
    top: 27px;
    z-index: 999;
    background-color: white;
    width: 100%;
    box-shadow: 0px 1px 4px -2px #000000;
  }

  .dropdown-merchante div {
    padding: 5px 0px 10px 10px;
    cursor: pointer;
    border-bottom: 1px solid rgba(61, 61, 61, 0.2);
  }

  .dropdown-merchante div:hover {
    background-color: #222222;
  }

  .dropdown-merchante div:hover p {
    color: white;
  }

  .search-select {
    height: 28px;
  }

  .search-select input {
    height: 100%;
    -webkit-appearance: menulist;
    -moz-appearance: menulist;
    appearance: menulist;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/search-select/search-select.vue